import { axiosRequest, workflowApi } from "../../configs/axios.config";
import { commonsHelper } from "../../../helpers";

export class SelectionProcessesService {
  getById(id, success, error) {
    axiosRequest
      .get(`/selection_processes/${id}`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  /**
   * Fetch selection processes basic info using JSON:API adapter.
   * Returns array of resources under data key.
   */
  getBasicInfoList(page = 1, items = 10000, params = {}) {
    return axiosRequest
      .get(`/selection_processes/search?basic_info=true&page=${page}&items=${items}`, { params })
      .then(({ data }) => data.data);
  }

  getCurrents(page = 1, items = 99999, params = {}) {
    return axiosRequest
      .post(`/selection_processes/search?page=${page}&items=${items}`, params)
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }

  getAuthors(success, error) {
    axiosRequest
      .get("/selection_processes/authors")
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  supend(id, success, error) {
    axiosRequest
      .post(`/selection_processes/${id}/suspend`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  activate(id, success, error) {
    axiosRequest
      .post(`/selection_processes/${id}/activate`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  close(id, params, success, error) {
    axiosRequest
      .post(`/selection_processes/${id}/close`, params)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  updateById(id, data, success, error) {
    axiosRequest
      .put(`/selection_processes/${id}`, data)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getPostulations(page = 1, items = 99999, params = {}) {
    return axiosRequest
      .post(
        `/selection_processes/applicant_postulations?page=${page}&items=${items}`,
        params
      )
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }

  listUsers(
    ids = [],
    page = 1,
    items = 10000,
    term = "",
    type = "admin_multidomain_and_colab"
  ) {
    return axiosRequest.post(
      `/users/search?page=${page}&items=${items}&type=${type}`,
      {
        q: {
          id_in: ids,
          full_name_or_email_cont_all: term && String(term).trim() !== "" ? String(term).trim().split(/\s+/) : undefined,
          active_eq: true,
        },
      }
    );
  }

  getJobOffer(token, tenant, success, error) {
    const url = tenant
      ? `/selection_processes/tenants/${tenant}/job_offer/${token}`
      : `/selection_processes/${token}/job_offer`;
    axiosRequest
      .get(url)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getPostulationFormApplicant(token, tenant, success, error) {
    const url = tenant
      ? `/selection_processes/tenants/${tenant}/postulation_form_applicant/${token}`
      : `/selection_processes/${token}/postulation_form_applicant`;
    axiosRequest
      .get(url)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  createExternalApplicant(token, tenant, params, success, error) {
    const url = tenant
      ? `/selection_processes/tenants/${tenant}/create_external_applicant/${token}`
      : `/selection_processes/${token}/create_external_applicant`;
    axiosRequest
      .post(url, params)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  createManualApplicant(token, params, success, error) {
    const url = `/selection_processes/${token}/create_applicant_from_selection_process`;
    axiosRequest
      .post(url, params)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  delete(id, success, error) {
    axiosRequest
      .delete(`/selection_processes/${id}`)
      .then(({ data }) => success(data))
      .catch(({ errorResp }) => error(errorResp));
  }

  updateRequestType(id, data, success, error) {
    axiosRequest
      .patch(`/selection_processes/${id}/update_request_type`, data)
      .then(({ data }) => success(data))
      .catch(({ errorResp }) => error(errorResp));
  }

  saveQuestions(id, params, success, error) {
    axiosRequest
      .post(`/selection_processes/${id}/save_questions`, params)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  fetchRuleElements(id_process, success, error) {
    axiosRequest
      .get(`/selection_processes/${id_process}/rule_elements`)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  fetchRuleTestElements(success, error) {
    axiosRequest
      .get(`/test_structures/kanban_tests`)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  updateHiring(id, params, success, error) {
    axiosRequest
      .put(`/selection_processes/${id}/update_hiring`, params)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  fetchListSelectedTests(id, success, error) {
    const url = `/selection_processes/${id}/get_tests`;
    axiosRequest
      .get(url)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  saveSelectedTests(id, data, success, error) {
    const url = `/selection_processes/${id}/update_tests`;
    axiosRequest
      .post(url, data)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  validateEmail(id, email, current_email, success, error) {
    axiosRequest
      .get(
        `/selection_processes/${id}/validate_email?email=${email}&current_email=${current_email}`
      )
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  bulkMove(id, params, success, error) {
    axiosRequest
      .put(`/selection_processes/${id}/bulk_move`, params)
      .then(({ data }) => success(data))
      .catch(err => error(err))
  }

  fetchWorkflowConfigurations(success, error) {
    workflowApi
      .post(`/workflow_configurations/search`, {
        q: { app_module_id_in: [169, 199, 2] },
        items: 10000,
      })
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }
}
